import React from "react";
import PageHero from "@/components/PageHero";
import { Container, GoldButton } from "@/components/shared";

const stops = [
  { title: "The Harbour & waterfront", body: "Start where the city started — at the water. The wharves and the harbour walk set the scale of the daughter city." },
  { title: "Boston Common", body: "The oldest public park in the country, and a fine place to understand how the settlement grew from its three hills." },
  { title: "The North End", body: "Narrow streets, old trades, and makers still at work — including copper raised by hand a few doors from the water." },
];

const MASS = "https://images.unsplash.com/photo-1717174704421-0ce3dc8a7225?crop=entropy&cs=srgb&fm=jpg&q=85&w=940";

export default function VisitMassachusetts() {
  return (
    <div>
      <PageHero
        kicker="Visit · The daughter city"
        title="Two days in Boston, Massachusetts"
        intro="A great harbour city that rewards walking. Begin at the water, cross the Common, and end among the makers of the North End."
      >
        <GoldButton as="link" to="/visit/itineraries/stump-to-common">See the full crossing route →</GoldButton>
      </PageHero>

      <section className="py-16 sm:py-24">
        <Container>
          <img src={MASS} alt="Boston, Massachusetts" className="w-full h-[360px] object-cover border border-[#D6D3CB] mb-12" />
          <div className="max-w-3xl space-y-8">
            {stops.map((s, i) => (
              <div key={i} className="flex gap-6">
                <span className="font-serif text-3xl text-[#CDA434] w-10 shrink-0">{i + 1}</span>
                <div className="pb-8 border-b border-[#D6D3CB] flex-1">
                  <h3 className="font-serif text-xl text-[#1E1E2F] mb-2">{s.title}</h3>
                  <p className="font-sans text-base text-[#1B2430] leading-relaxed">{s.body}</p>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
